import { DatabaseUsageTab } from '../admin/DatabaseUsageTab';
import { TokenUsageTab } from '../admin/TokenUsageTab';
import { UsersTab } from '../admin/UsersTab';

export interface ModuleSectionScreen {
  title: string;
  description: string;
  render: () => JSX.Element;
}

/**
 * Sections that appear in more than one module.
 *
 * Token Usage and Database Usage show up under both Licensing & Usage and
 * Administration & Configuration. Both modules spread THIS object into their own
 * section maps, so the two are one definition — same title, same description, same
 * component, same endpoint — rather than two copies that drift.
 */
export const SHARED_SECTIONS: Record<string, ModuleSectionScreen> = {
  users: {
    title: 'Users',
    description: 'Accounts, roles, module access and account lifecycle.',
    render: () => <UsersTab />,
  },
  'token-usage': {
    title: 'Token Usage',
    description: 'LLM token consumption across the platform.',
    render: () => <TokenUsageTab />,
  },
  'database-usage': {
    title: 'Database Usage',
    description: 'How much storage this install is consuming, by application.',
    render: () => <DatabaseUsageTab />,
  },
};
